import React, { useState } from 'react';
import {
  Box,
  Button,
  Checkbox,
  Popover,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverTrigger,
  Portal,
  VStack,
  HStack,
  PopoverHeader,
  Text,
  Icon,
} from '@chakra-ui/react';
import { MdFilterList } from 'react-icons/md';

interface MenuProps {
  headers: {
    label: string;
    key: string;
    width?: string;
    isVisible: boolean;
  }[];
  onFilter: (updatedHeaders: {
    label: string;
    key: string;
    width?: string;
    isVisible: boolean;
  }[]) => void;
  children?: React.ReactNode;
  isNewLayout?: boolean
}

function Menu({ headers, onFilter, children, isNewLayout = false }: MenuProps) {
  const [localHeaders, setLocalHeaders] = useState(headers);

  const handleCheckboxChange = (key: string, isChecked: boolean) => {
    setLocalHeaders((prev) =>
      prev.map((header) =>
        header.key === key ? { ...header, isVisible: isChecked } : header
      )
    );
  };

  const applyFilters = () => {
    onFilter(localHeaders);
  };

  return (
    <Popover closeOnBlur={false} placement="auto-start">
      <PopoverTrigger>
        <Box textAlign="center" cursor="pointer">
          {children || (
            <HStack>
              <Icon boxSize={6} as={MdFilterList} />
              <Text>Selecionar Colunas</Text>
            </HStack>
          )}
        </Box>
      </PopoverTrigger>
      <Portal>
        <PopoverContent w={isNewLayout ? '200px' : "300px"} borderRadius={isNewLayout ? "12px 12px 12px 12px" : "12px 12px 0 0"} display={isNewLayout ? 'flex' : 'block'} flexDir={"row-reverse"}>
          <PopoverHeader bg={isNewLayout ? "#117baa" : "#0f4f6d"} color="white" borderRadius={isNewLayout ? "0 12px 12px 0" : "12px 12px 0 0"} fontSize="15px">
            {isNewLayout ? null : (
              <HStack>
                <Icon boxSize={6} as={MdFilterList} />
                <Text fontSize="lg">Selecionar Colunas</Text>
              </HStack>
            )}
          </PopoverHeader>
          <PopoverCloseButton color="white" />
          <PopoverBody p={4}>
            <VStack align="stretch" spacing={3}>
              {localHeaders.map((header) => (
                <Checkbox
                  key={header.key}
                  isChecked={header.isVisible}
                  onChange={(e) => handleCheckboxChange(header.key, e.target.checked)}
                >
                  {header.label}
                </Checkbox>
              ))}
              <HStack justify={isNewLayout ? "flex-start" : "flex-end"} mt={4}>
                <Button size="sm" colorScheme={isNewLayout ? 'linkedin' : "blue"} p={isNewLayout ? 1 : 2} bg={isNewLayout ? "#117baa" : 'facebook.600'} onClick={applyFilters}>
                  <div style={isNewLayout ? {
                    padding: '2px 8px',
                    border: '1px solid #fff',
                    borderRadius: '4px'
                  } : undefined}>
                    Aplicar
                  </div>
                </Button>
              </HStack>
            </VStack>
          </PopoverBody>
        </PopoverContent>
      </Portal>
    </Popover>
  );
}

export default Menu;
